import { createRouter as createTanstackRouter } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';

let routerSingleton: ReturnType<typeof createTanstackRouter> | null = null;

export function createRouter() {
  const queryClient = new QueryClient();

  return createTanstackRouter({
    routeTree,
    // Ensure we never clamp navigation to a sub-path like `/app`.
    // We treat `/app/*` and `/auth/*` as SPA routes, but the router still
    // needs to recognize marketing routes at `/`.
    basepath: '/',
    context: {
      queryClient,
    },
    scrollRestoration: true,
  });
}

export function getRouter() {
  // SSR: always create a fresh router so request state (redirects, matches)
  // never leaks between concurrent or sequential server requests.
  // Client: use a singleton so a single router instance handles all navigations.
  if (typeof window === 'undefined') {
    return createRouter();
  }
  if (!routerSingleton) {
    routerSingleton = createRouter();
  }
  return routerSingleton;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
